import React from 'react';
import PropTypes from 'prop-types';
import { Navbar } from 'react-bootstrap';
import classNames from 'classnames';

import { topNavbarBreakpoint } from 'config';

import NavbarTopElements from './NavbarTopElements';

const NavbarTopContainer = ({
	showDropShadow,
	isChat,
	navbarPosition,
	navbarCollapsed,
	handleBurgerMenuToggle
}) => {

	return(
		<Navbar
			className={classNames('navbar-glass fs--1 navbar-top sticky-kit', {'navbar-glass-shadow': showDropShadow && !isChat,})}
			expand={navbarPosition === 'top' || navbarPosition === 'combo' || navbarPosition === 'double-top' ? topNavbarBreakpoint : true} >
				{/*{ navbarPosition === 'double-top' ? (
					<DoubleTopNavbarElements
						navbarCollapsed={navbarCollapsed}
						navbarPosition={navbarPosition}
						handleBurgerMenuToggle={handleBurgerMenuToggle} />
				) : (*/}
				<NavbarTopElements
					navbarCollapsed={navbarCollapsed}
					navbarPosition={navbarPosition}
					handleBurgerMenuToggle={handleBurgerMenuToggle} />
				{/*})}*/}
				
		</Navbar>
	)
};

NavbarTopContainer.propTypes = {
	showDropShadow: PropTypes.bool,
	isChat: PropTypes.bool,
	navbarPosition: PropTypes.string,
	navbarCollapsed: PropTypes.bool,
	handleBurgerMenuToggle: PropTypes.func,
};

export default NavbarTopContainer;